var ProductTrackingNames;
(function (ProductTrackingNames) {
    ProductTrackingNames["perks"] = "perks";
    ProductTrackingNames["recognition"] = "recognition";
    ProductTrackingNames["medical"] = "medical";
    ProductTrackingNames["insights"] = "insights";
})(ProductTrackingNames || (ProductTrackingNames = {}));
export default ProductTrackingNames;
